import { call, put, takeLatest } from 'redux-saga/effects'
import { api } from '~/services/api'
import {
  getAllGeneralUserSuccess,
  getAllGeneralUserFailed,
  GET_ALL_GENERAL_USER_START,
} from '../../actions/general'

/**
 * get list general user
 * @param {any} params Params will be sent to server
 * @returns {Promise}
 */
const getListGeneralUserApi = (props) => {
  var uri = `/users/general`
  return api.get(uri, props)
}

/**
 * [Worker]
 * Handle get data request and response
 * @param {object} action
 */
function* doGetListGeneralUser(action) {
  try {
    const response = yield call(getListGeneralUserApi, action?.payload)
    yield put(getAllGeneralUserSuccess(response?.data))
    // Call callback action if provided
    if (action.onSuccess) {
      yield action.onSuccess(response?.data)
    }
  } catch (error) {
    yield put(getAllGeneralUserFailed())
    // Call callback action if provided

    if (action.onError) {
      yield action.onError(error)
    }
  }
}

/**
 * [Watcher]
 * Watch get list general user
 */
export default function* watchGetListGeneralUser() {
  yield takeLatest(GET_ALL_GENERAL_USER_START, doGetListGeneralUser)
}
